export const localeStorageKey = 'preferredLocale';
export const themeStorageKey = 'preferredTheme';